<template>
    <div class="component dialogue-outro section" data-shape-id="dialogueOutro" data-logo-color-scheme="inverted">
        <div class="wrapper wrapper-large">
            <div class="slide-illustration">
                <img src="../../../assets/svg/avatar/lady-03.svg" />
            </div>
            <div class="slide-copy">
                <h2 class="major-heading">
                    Matching<br />
                    perspectives
                </h2>
                <p>
                    To create experiences that meet user expectations and are also differentiating and on brand, we must
                    link both perspectives from the beginning.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DialogueOutro',
    };
</script>

<style scoped lang="scss">
    .component {
        position: relative;
        width: 100%;
        color: #ffffff;

        .wrapper {
            @include flex($align-items: center);
            max-height: 100vh;
        }

        @keyframes anim-fade-in-from-left {
            from {
                transform: translateX(-25px);
                opacity: 0;
            }

            to {
                transform: translateX(0px);
                opacity: 1;
            }
        }

        &.active {
            @keyframes anim-fade-in {
                from {
                    transform: translateY(15px);
                    opacity: 0;
                }

                to {
                    transform: translateY(0px);
                    opacity: 1;
                }
            }

            .slide-illustration {
                animation: anim-fade-in-from-left 1s 0.5s forwards;
            }

            .slide-copy {
                animation: anim-fade-in 1s 0.4s forwards;
            }
        }

        &.on-leave {
            .slide-illustration,
            .slide-copy {
                animation: anim-fade-out-to-left 0.2s forwards;
            }

            @keyframes anim-fade-out-to-left {
                from {
                    transform: translateX(0px);
                    opacity: 1;
                }

                to {
                    transform: translateX(-25px);
                    opacity: 0;
                }
            }
        }
    }

    .slide-illustration {
        display: none;

        @media (min-width: breakpoint('large')) {
            opacity: 0;
            display: block;
            width: 50%;
            height: 100vh;
        }

        img {
            position: absolute;
            bottom: 0;
            height: 85%;
            display: none;

            @supports (top: 0) {
                display: block;
            }

            @media (max-width: 1500px) {
                left: -10vw;
                height: 80%;
            }

            @media (max-width: breakpoint('extra-large')) {
                height: 75%;
            }
        }

        @media (max-width: 1500px) {
            width: 40%;
        }
    }

    .slide-copy {
        width: 50%;
        position: relative;
        opacity: 0;

        @media (max-width: 1500px) {
            width: 60%;
        }

        @media (max-width: breakpoint('large') - 1) {
            width: 100%;
        }
    }
</style>
